//空调系统界面，中央面板
export const DEFAULTCOOLINGTOWERCONTENT = [{
    name: '总管水流量',
    value: "-",
    unit: 'L/min',
}, {
    name: '总管回水温度',
    value: "-",
    unit: '℃',
}, {
    name: '今日补水',
    value: "-",
    unit: 'm³',
}, {
    name: '阀门开度',
    value: "-",
}, {
    name: '总管出水温度',
    value: "-",
    unit: '℃',
}]

export const DEFAULTWATERTOOLSCONTENT = [{
    name: '总管出水温度',
    value: '-',
    unit: '℃',
}, {
    name: '总管出水流量',
    value: '-',
    unit: 'L/min',
}, {
    name: '总管出水压力',
    value: '-',
    unit: 'Kpa',
}, {
    name: '总管回水温度',
    value: '-',
    unit: '℃',
}, {
    name: '总管回水流量',
    value: '-',
    unit: 'L/min',
}, {
    name: '总管回水压力',
    value: '-',
    unit: 'Kpa',
}]

//设备管理，参数名称对应
export const PARAMKEYTONAME = {
    Electricity:'电量',
    Power:'功率',
    PowerRate:'负载率',
    Water:'用水量',
    Aperture:'开度',
    Flow:'实时流量',
    Temperature:'温度',
    Humidity:'湿度',
    AirPress:'压力',
    RelativeHumidity:'相对湿度',
    WetBulbTemperature:'湿球温度',
    WindSpeed:'风速',
}

//气象站
export const ANGLEDEFAULT = {
    0:"北",
    1:"东北",
    2:"东",
    3:"东南",
    4:"南",
    5:"西南",
    6:"西",
    7:"西北",
}

export const WEATHERDEFAULT = {
    0:"晴天",
    1:"雨雪天",
    2:"阴天",
    3:"多云",
}